import { gsap } from "gsap";

export default function () {
    if (!document.querySelector('[data-block="claim"]'))
        return gsap.timeline()

    const claimTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: '[data-block="claim"]',
            start: 'top center',
            end: 'top top',
            scrub: true,
        }
    })

    claimTimeline.to('[data-block="services"]', { opacity: 0 })
        .from('[data-block="claim-asset"]', { scale: 0, translateY: '-50vh', transformOrigin: '50% 50%' }, '<')
        .from('[data-block="claim-content"]', { opacity: 0 }, '<')
        .from('[data-block="claim-bg"]', { opacity: 0 }, '-=.2')

    return claimTimeline
}